import { DataBean } from "../DataBean";

export class ActaComiteBank extends DataBean {


    public async getActaComiteBank(page:any,rows:any,props:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getActaComiteBank_Number_Number_java.util.Map", [page,rows,props]);
    }
   

    

 
}